<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        dark
        v-on="on"
      >
        Add Skill Level
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      class="mb-0"
    > 
      <template v-slot:header>
        <v-card-title>
          <div class="px-2">
            <h4 class="title font-weight-light">
              {{ skill.name.toUpperCase() }}
            </h4>
            <p class="category font-weight-thin">
              Add Skill Level
            </p>
          </div>
          <v-spacer />
          <v-btn  
            text
            icon 
            color="white"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="level"
                v-validate="'min_value:1|max_value:5|required'"   
                :error-messages="errors.collect('level')"     
                type="number"           
                data-vv-name="level" 
                readonly               
                label="Level"
              />
              <v-textarea
                v-model="description"
                v-validate="'required'"
                :error-messages="errors.collect('description')"
                :rows="3"
                data-vv-name="description"                
                label="Description"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :loading="progressing"
          class="font-weight-light"
          color="success"          
          @click="submitForm({addAnother: true})"
        >
          Save & Add Another
        </v-btn>
        <v-btn
          :loading="progressing"
          class="font-weight-light"
          color="success"          
          @click="submitForm"
        >
          Save
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      skill: {
        type: Object,
        required: true,
      },
      level: {
        type: Number,
        required: true,
      },
    },
    data () {
      return {
        progressing: false,
        dialog: false,
        description: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (value) this.resetForm()   
      },
    },
    methods: {    
      submitForm ({ addAnother = false }) {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.skillLevels().create(this.skill.id, {
              level: this.level,
              description: this.description,
            })
              .then((res) => {
                if (res.status === 201) {
                  this.$emit('created', res.data)  
                  this.$snack({ message: 'Added new skill level' })
                  this.description = ''
                  if (!addAnother) this.setDialog(false)                
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        this.dialog = status
      },
      resetForm () {
        this.description = null
        this.$validator.reset()
      },
    },
  }
</script>
